/* istanbul ignore file */
import { getPartnerImageUrl } from "utils/getImageUrl";

const buildImagesLinks = (cdnUrl: string, partner: string, campaign: string) => {
  return {
    logo: getPartnerImageUrl(`${partner}/${campaign}/logo/regular.webp`, cdnUrl),
    logoLandscape: getPartnerImageUrl(`${partner}/${campaign}/logo/wide.webp`, cdnUrl),
    logoWhite: getPartnerImageUrl(`${partner}/${campaign}/logo/regular_white.webp`, cdnUrl),
    logoLandscapeWhite: getPartnerImageUrl(`${partner}/${campaign}/logo/wide_white.webp`, cdnUrl),
    logoEAA: getPartnerImageUrl(`${partner}/${campaign}/logo/regular_eaa.webp`, cdnUrl),
    banner: {
      desktop: getPartnerImageUrl(`${partner}/${campaign}/banner/desktop.webp`, cdnUrl),
      tablet: getPartnerImageUrl(`${partner}/${campaign}/banner/tablet.webp`, cdnUrl),
      mobile: getPartnerImageUrl(`${partner}/${campaign}/banner/mobile.webp`, cdnUrl),
    },
    carousel: {
      baseUrl: getPartnerImageUrl(`${partner}/${campaign}/carousel/`, cdnUrl),
      promoUrl: getPartnerImageUrl(`${partner}/${campaign}/carousel/promo/`, cdnUrl),
    },
    card: {
      desktop: getPartnerImageUrl(`${partner}/${campaign}/card/desktop.webp`, cdnUrl),
      tablet: getPartnerImageUrl(`${partner}/${campaign}/card/tablet.webp`, cdnUrl),
      mobile: getPartnerImageUrl(`${partner}/${campaign}/card/mobile.webp`, cdnUrl),
    },
    cross: {
      desktop: getPartnerImageUrl(`${partner}/${campaign}/cross/desktop.webp`, cdnUrl),
      tablet: getPartnerImageUrl(`${partner}/${campaign}/cross/tablet.webp`, cdnUrl),
      mobile: getPartnerImageUrl(`${partner}/${campaign}/cross/mobile.webp`, cdnUrl),
    },
  };
};

export default buildImagesLinks;
